import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const RemovePlanAccountAlert: React.FC<Props> = ({ alert }: Props) => {
  const { t } = useTranslation()
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.membershipStatusChanged')}</p>
      <p className="mb-2.5">{t('content.membershipStatusExplanation')}</p>
    </AlertCard>
  )
}

export default RemovePlanAccountAlert
